import athleticsBoldTTf from './Athletics-Bold.ttf';
import athleticsBoldEot from './Athletics-Bold.eot';
import athleticsBoldWoff from './Athletics-Bold.woff';
import athleticsBoldWoff2 from './Athletics-Bold.woff2';

/* Webfont: Athletics-Bold */
export const athleticsFont = {
    bold: {
        fontFamily: 'AthleticsBold',
        src: `url('${athleticsBoldEot}?#iefix') format('embedded-opentype'), url('${athleticsBoldWoff}') format('woff'),
    url('${athleticsBoldWoff2}') format('woff2'), url('${athleticsBoldTTf}') format('truetype')`,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontDisplay: 'swap',
        textRendering: 'optimizeLegibility',
    },
};
